module.exports = __webpack_public_path__ + "static/media/heartipro-charger-1.ac5e4971.png";